export const styles = theme => ({
  checked: {
    color: `${theme.palette.primary.main} !important`,
  },
});
